/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import UserQueryResult from './UserQueryResult';

/**
 * The UserOutputCmsUsers model module.
 * @module model/UserOutputCmsUsers
 * @version 1.0
 */
class UserOutputCmsUsers {
    /**
     * Constructs a new <code>UserOutputCmsUsers</code>.
     * @alias module:model/UserOutputCmsUsers
     */
    constructor() { 
        
        UserOutputCmsUsers.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserOutputCmsUsers</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserOutputCmsUsers} obj Optional instance to populate.
     * @return {module:model/UserOutputCmsUsers} The populated <code>UserOutputCmsUsers</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserOutputCmsUsers();

            if (data.hasOwnProperty('users')) {
                obj['users'] = ApiClient.convertToType(data['users'], [UserQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/UserQueryResult>} users
 */
UserOutputCmsUsers.prototype['users'] = undefined;






export default UserOutputCmsUsers;

